import React, { useState } from "react";
import { Link } from "react-router-dom";
import ErrorIcon from "../../base/assets/icons/ErrorIcon";
import SuccessIcon from "../../base/assets/icons/SuccessIcon";
import fixObject from "../../base/utils/convert_to_object";
import moneyFormat from "../../base/utils/moneyFormat";
import useQuery from "../../base/utils/useQuery";

export default function AfterPayment() {
  const [status] = useState(window.location.pathname.split("/")[3]);
  const [code] = useState(window.location.pathname.split("/")[4]);
  const [price] = useState(window.location.pathname.split("/")[5]);
  let query = useQuery();
  let url = query?.get("url");
  let title = query?.get("title");
  let description = query?.get("description");
  let date = query?.get("date");

  return (
    <div className="container-fluid px-2">
      <div className="row mx-0 vh-100">
        <div className="col-12 align-self-center">
          <div className="text-center bg-white shadow-main rounded12 p-5 mb-2">
            {status == 1 ? (
              <div>
                <SuccessIcon />
                <h5 className="text-green mt-4 fw-bolder">
                  پرداخت با موفقیت انجام شد
                </h5>
              </div>
            ) : (
              <div>
                <ErrorIcon />
                <h5 className="text-pink mt-4 fw-bolder">پرداخت ناموفق</h5>
              </div>
            )}
            <div className="mt-4">
              <div className="row mx-0 mb-3">
                <div className="col text-center">
                  <span className="text-main fs-5 fw-bolder">
                    مبلغ: {moneyFormat(price)}
                  </span>
                </div>
              </div>
              <div className="row mx-0 mb-3">
                <div className="col text-center">
                  <span className="small fw-bolder">کد رهگیری: {code}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row mx-0">
            {window.location.search &&
            fixObject(window.location.search).client === "android" ? (
              <a
                className="px-0"
                href={`irana://pwa_payment.app?url=${
                  url || window.location.href
                }`}
              >
                <button
                  className={`btn py-2 small rounded10 fw-bolder border-0 ${
                    status == 1 ? "bg-light-green" : "bg-red"
                  } text-white col-12 mt-3`}
                >
                  بازگشت به اپلیکیشن
                </button>
              </a>
            ) : (
              <Link
                className="text-white w-100 h-100 d-block px-0"
                to={url || "/my-ticket-list"}
              >
                <button
                  className={`btn border-0 rounded10 text-white small py-2 fw-bolder ${
                    status == 1 ? "bg-light-green" : "bg-red"
                  } col-12 my-1`}
                >
                  تایید
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
